<template>
    <div>
        <template v-for="action in topLevelActions">
            <component
                :config="action"
                :changeUrl="changeUrl"
                :changeQuery="changeQuery"
                :changeSection="changeSection"
                :addNotification="addNotification"
                :is="action.component"
                ></component>
        </template>
        <button type="button"
            v-on:click="loadNewInstance"
            v-if="_.get(config, 'creatable', true)"
            class="btn btn-rounded btn-icon btn-success">
            <i class="material-icons">add</i>Add {{ __(type, ['titleCase']) }}
        </button>
    </div>
</template>
<script>
import Vue from 'vue';
import V from 'voca';
import _ from 'lodash';
import { plural, singular } from 'pluralize';

export default {
    props: [
        'content', 'config', 'timestamp',
        'changeUrl', 'changeQuery', 'changeSection',
        'addNotification',
    ],

    components: {

    },

    watch: {

    },

    computed: {
        type() {
            return _.get(this.content, 'type');
        },

        topLevelActions() {
            return _.get(this.config, 'topLevelActions', []);
        },
    },

    mounted() {
        console.log('Component mounted.')
    },

    destroyed() {

    },

    methods: {
        loadNewInstance() {
            const selfUrl = _.get(this.content, 'links.self');
            const newInstanceUrl = _.get(this.content, 'links.new');

            if (newInstanceUrl) {
                this.changeUrl(newInstanceUrl);
            } else {
                // get new url from existing one by replacing id
                this.changeUrl(selfUrl.replace(/\w+$/, '_'));
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/ToplevelToolbarComponent.vue